export const DEFAULT_PLACEHOLDER = '검색어를 입력해 주세요.'

export enum SearchHeaderMode {
  SEARCH = 'SEARCH',
  RESULT = 'RESULT',
}

export type SearchHeaderModeType = keyof typeof SearchHeaderMode
